export const authUrl = (): string => `${import.meta.env.VITE_API_BASE_URL}oauth`;
export const authTokenUrl = (): string => `${authUrl()}/token`;
export const authRevokeUrl = (): string => `${authUrl()}/revoke`;
export const authForgotPasswordUrl = (): string => `${authUrl()}/forgot-password`;
export const authResetPasswordUrl = (): string => `${authUrl()}/reset-password`;